<template>
  <div class="pa-4">
    <custom-tabs v-if="rerender" v-model="tabs" :tab-items="tabItems" grow>
      <template v-slot:staticItems>
        <v-tab-item>
          <call-logs-list @reload="permissionGranted"/>
        </v-tab-item>

        <v-tab-item>
          <send-contacts ref="sendSettings" @reload="reloadSend"/>
        </v-tab-item>
      </template>
    </custom-tabs>
  </div>
</template>

<script>
import CallLogsList from "@/view/pages/contacts/callLogsList.vue";
import SendContacts from "@/view/pages/contacts/sendContacts.vue";

export default {
  name: "contactList",

  components: {SendContacts, CallLogsList},

  data() {
    return {
      rerender: true,
      tabs: 0,
      tabItems: [
        {text: 'لیست تماس‌ها', icon: 'phone'},
        {text: 'تنظیمات', icon: 'cogs'}
      ],
      loading: false,
    }
  },

  methods: {
    reloadSend() {
      this.rerender = false

      this.$nextTick(() => {
        this.rerender = true
      })
    },
    permissionGranted() {
      this.tabs = 1

      setTimeout(() => {
        this.$refs.sendSettings.setDefault(false)
      }, 1000)
    }
  }
}
</script>

<style scoped>

</style>